<template>
  <div class="next-steps">
    <h3 v-t="'success.nextSteps.title'" />
    <ol>
      <li>
        <h4 v-t="'success.nextSteps.steps.0'" />
        <success-payment-share />
      </li>
      <li>
        <h4 v-t="'success.nextSteps.steps.1'" />
        <base-button
          small
          @click.native="handleBuyDomain"
          v-t="'success.nextSteps.buyDomain'"
          :href="buyDomainLink"
          target="_blank"
          rel="noopener"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import store from '@/store';
import SuccessPaymentShare from '@/components/SuccessPaymentShare/SuccessPaymentShare';
import { getBuyDomainLink } from '@/utils/getSiteUrls';
import { YANDEX_METRIKA_CODE } from '@/constants/metrika';

export default {
  components: {
    SuccessPaymentShare,
  },
  computed: {
    buyDomainLink: () => getBuyDomainLink(store),
  },
  methods: {
    handleBuyDomain() {
      this.sendGAEvent('buy domain');
      this.sendYMEvent('buy-domain');
    },
    sendGAEvent(action) {
      if (window.gtag) {
        window.gtag('event', action, { event_category: 'More buttons' });
      }
    },
    sendYMEvent(event) {
      if (window.ym) {
        window.ym(YANDEX_METRIKA_CODE, 'reachGoal', event);
      }
    },
  },
};
</script>

<style scoped src="./successPaymentNext.css"></style>
